export default class Events {
  constructor () {
    this.listeners = {}
  }
  on (name, fn) {
    if (!this.listeners[name]) {
      this.listeners[name] = []
    }
    this.listeners[name].push(fn)
  }
  emit (name, ...args) {
    if (!this.listeners[name]) {
      return
    }
    for (let fn of this.listeners[name]) {
      fn(...args)
    }
  }
  removeListener (name, fn) {
    if (!this.listeners[name]) {
      return
    }
    for (var i = this.listeners[name].length - 1; i >= 0; i--) {
      if (this.listeners[name][i] !== fn) {
        continue
      }
      this.listeners[name].splice(i, 1)
    }
  }
}
